
import { Card, CardContent } from "@/components/ui/card";
import { Package } from "lucide-react";

export const EmptyProductList = () => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center p-6 text-center">
        <Package className="h-12 w-12 text-muted-foreground mb-3" />
        <h3 className="font-semibold text-lg mb-1">Aucun produit</h3>
        <p className="text-sm text-muted-foreground">
          Vous n'avez pas encore ajouté de produit. Utilisez le bouton "Ajouter un produit" pour commencer.
        </p>
      </CardContent>
    </Card>
  );
};
